import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function CoffeeHome() {
  const navigate = useNavigate();

    useEffect(() => {
    document.title = 'Coffee Gus•to | Home';

    const SECRET_CODE = 'adminstaff';
    let typedSequence = '';
    let resetTimer;

    const handleKeyPress = (e) => {
      typedSequence += e.key.toLowerCase();
      if (typedSequence.length > SECRET_CODE.length) {
        typedSequence = typedSequence.substring(typedSequence.length - SECRET_CODE.length);
      }
      if (typedSequence === SECRET_CODE) {
        sessionStorage.setItem('secretCodeEntered', 'true');
        navigate('/login');
        typedSequence = '';
      }
      clearTimeout(resetTimer);
      resetTimer = setTimeout(() => { typedSequence = ''; }, 2000);
    };

    document.addEventListener('keypress', handleKeyPress);
    return () => {
      document.removeEventListener('keypress', handleKeyPress);
      clearTimeout(resetTimer);
    };
  }, [navigate]);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="h-screen overflow-y-auto snap-y snap-mandatory bg-gray-900 custom-scrollbar">
      <style>{`
        .custom-scrollbar {
          scrollbar-width: thin;
          scrollbar-color: #e07b39 #1a1a1a;
        }
        .custom-scrollbar::-webkit-scrollbar {
          width: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: #1a1a1a;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background-color: #e07b39;
          border-radius: 8px;
          border: 2px solid #1a1a1a;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background-color: #f5945a;
        }
      `}</style>

      <nav className="fixed top-0 left-0 right-0 z-50 px-8 py-5 bg-black border-b border-white/5">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div
            className="cursor-pointer select-none"
            onClick={() => {
              sessionStorage.setItem('secretCodeEntered', 'true');
              navigate('/login');
            }}
          >
            <img
              src="https://hbylyyfhigscnrozlxqe.supabase.co/storage/v1/object/public/coffee-gusto/CGLOGOBAR-removebg.png"
              alt="Coffee Gusto"
              className="h-10 w-auto object-contain"
            />
          </div>
          <div className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollTo('home')} className="text-white hover:text-orange-400 transition text-sm bg-transparent border-0 cursor-pointer">Home</button>
            <button onClick={() => scrollTo('why')} className="text-white hover:text-orange-400 transition text-sm bg-transparent border-0 cursor-pointer">Why Us</button>
            <button onClick={() => scrollTo('franchise')} className="text-white hover:text-orange-400 transition text-sm bg-transparent border-0 cursor-pointer">Franchise</button>
            <button onClick={() => scrollTo('contact')} className="text-white hover:text-orange-400 transition text-sm bg-transparent border-0 cursor-pointer">Contact</button>
          </div>
        </div>
      </nav>

      <div id="home" className="relative h-screen flex items-center snap-start">
        <img
          src="https://hbylyyfhigscnrozlxqe.supabase.co/storage/v1/object/public/coffee-images/coffeeHome.jpg"
          alt=""
          fetchpriority="high"
          loading="eager"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <div className="relative z-10 px-8 md:px-16 lg:px-24 max-w-4xl">
          <h1 className="text-white text-5xl md:text-7xl font-bold mb-6 leading-tight">
            Your Daily Retreat,<br />
            One Cup at a Time.
          </h1>
          <p className="text-white text-lg md:text-xl mb-8 max-w-2xl leading-relaxed">
            Whether you're here to find your focus or catch up with a friend, we provide the perfect blend of cozy atmosphere and world-class beans.
          </p>
          <button
            onClick={() => scrollTo('why')}
            className="bg-orange-600 hover:bg-orange-700 text-white px-8 py-3 rounded-md text-lg font-medium transition transform hover:scale-105"
          >
            See More
          </button>
        </div>
      </div>

      <section id="why" style={{ backgroundColor: '#f5efe6' }} className="px-8 md:px-16 lg:px-24 min-h-screen flex items-center snap-start">
        <div className="max-w-7xl mx-auto">
          <p className="text-xs tracking-widest uppercase font-medium mb-3" style={{ color: '#e07b39' }}>Featured</p>

          <div className="grid md:grid-cols-2 gap-16 items-center">

            <div>
              <h2 className="font-bold leading-tight mb-4" style={{ color: '#1a110a', fontSize: 'clamp(36px, 4vw, 58px)', fontFamily: 'serif' }}>
                Why Choose Us?
              </h2>
              <p className="text-base leading-relaxed mb-8 font-light" style={{ color: '#6b5a4a', maxWidth: '420px' }}>
                Sourced from ethical farms across Southeast Asia, our beans are roasted to perfection and brewed with care. We bring premium coffee culture to every corner — one cup at a time. Whether you're a loyal regular or a first-time visitor, Coffee Gusto is your home away from home.
              </p>

              <div className="flex gap-8 mb-9">
                {[['11', 'Branches'], ['98%', 'Satisfaction'], ['5★', 'Rating']].map(([num, lbl]) => (
                  <div key={lbl}>
                    <div className="text-3xl font-bold" style={{ color: '#e07b39', fontFamily: 'serif' }}>{num}</div>
                    <div className="text-xs uppercase tracking-widest mt-1" style={{ color: '#9b7e67' }}>{lbl}</div>
                  </div>
                ))}
              </div>

              <button
                onClick={() => scrollTo('franchise')}
                className="text-white text-sm font-medium uppercase tracking-widest px-8 py-3 rounded transition-all"
                style={{ backgroundColor: '#2a1f14', letterSpacing: '0.06em' }}
                onMouseEnter={e => e.target.style.backgroundColor = '#e07b39'}
                onMouseLeave={e => e.target.style.backgroundColor = '#2a1f14'}
              >
                Why Today
              </button>
            </div>

            <div className="relative">
              <div className="rounded-xl overflow-hidden" style={{ height: '460px' }}>
                <img
                  src="https://hbylyyfhigscnrozlxqe.supabase.co/storage/v1/object/public/coffee-gusto/interior.jpg"
                  alt="Coffee Gusto interior"
                  className="w-full h-full object-cover"
                />
              </div>
              <div
                className="absolute text-white text-center rounded-xl"
                style={{
                  bottom: '-20px', left: '-20px',
                  backgroundColor: '#e07b39',
                  padding: '18px 24px',
                  fontFamily: 'serif',
                }}
              >
                <div className="font-bold" style={{ fontSize: '20px' }}>8 Years of Craft</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="franchise" className="bg-gray-950 px-8 md:px-16 lg:px-24 min-h-screen flex items-center snap-start">
        <div className="max-w-7xl mx-auto">
          <p className="text-orange-500 text-xs tracking-widest uppercase font-medium mb-3">Get In Touch</p>
          <h2 className="text-white text-4xl md:text-5xl font-bold leading-tight mb-4">
            Ready to Franchise?<br />Let's Talk.
          </h2>
          <div className="w-12 h-0.5 bg-orange-600 mb-10" />

          <div className="grid md:grid-cols-2 gap-12 items-start">

            <div>
              <p className="text-white/50 text-base leading-relaxed mb-10 font-light max-w-md">
                Our franchise team is ready to guide you through every step. Reach out and we'll get back to you.
              </p>
              <div className="flex flex-col gap-6">
                {[
                  { label: 'Email', value: 'coffeegustoph@gmail.com', icon: <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 36 36"><path fill="#fff" d="M32 6H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2m-1.54 22H5.66l7-7.24l-1.44-1.39L4 26.84V9.52l12.43 12.37a2 2 0 0 0 2.82 0L32 9.21v17.5l-7.36-7.36l-1.41 1.41ZM5.31 8h25.07L17.84 20.47Z" class="clr-i-outline clr-i-outline-path-1"/><path fill="none" d="M0 0h36v36H0z"/></svg> },
                  { label: 'Phone', value: '+63 956 280 7813', icon: <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24"><path fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 3c0.5 0 2.5 4.5 2.5 5c0 1 -1.5 2 -2 3c-0.5 1 0.5 2 1.5 3c0.39 0.39 2 2 3 1.5c1 -0.5 2 -2 3 -2c0.5 0 5 2 5 2.5c0 2 -1.5 3.5 -3 4c-1.5 0.5 -2.5 0.5 -4.5 0c-2 -0.5 -3.5 -1 -6 -3.5c-2.5 -2.5 -3 -4 -3.5 -6c-0.5 -2 -0.5 -3 0 -4.5c0.5 -1.5 2 -3 4 -3Z"/></svg> },
                  { label: 'Address', value: 'Dasmariñas, Cavite', icon: <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24"><path fill="#fff" d="M16 10c0-2.21-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4s4-1.79 4-4m-6 0c0-1.1.9-2 2-2s2 .9 2 2s-.9 2-2 2s-2-.9-2-2"/><path fill="#fff" d="M11.42 21.81c.17.12.38.19.58.19s.41-.06.58-.19c.3-.22 7.45-5.37 7.42-11.82c0-4.41-3.59-8-8-8s-8 3.59-8 8c-.03 6.44 7.12 11.6 7.42 11.82M12 4c3.31 0 6 2.69 6 6c.02 4.44-4.39 8.43-6 9.74c-1.61-1.31-6.02-5.29-6-9.74c0-3.31 2.69-6 6-6"/></svg> },
                  { label: 'Hours', value: 'Mon–Fri, 11:00 AM – 11:00 PM', icon: <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24"><path fill="#fff" d="M12 4c4.411 0 8 3.589 8 8s-3.589 8-8 8s-8-3.589-8-8s3.589-8 8-8m0-2C6.477 2 2 6.477 2 12s4.477 10 10 10s10-4.477 10-10S17.523 2 12 2m3.8 13.4L13 11.667V7h-2v5.333l3.2 4.266z"/></svg> },
                ].map(({ label, value, icon }) => (
                  <div key={label} className="flex items-center gap-5">
                    <div className="w-11 h-11 bg-orange-600/15 rounded-lg flex items-center justify-center text-base flex-shrink-0">{icon}</div>
                    <div>
                      <div className="text-white/40 text-xs uppercase tracking-wide mb-0.5">{label}</div>
                      <div className="text-white text-sm font-medium">{value}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Inquiry form
            <div id="contact" className="bg-gray-800 border border-white/8 rounded-2xl p-8">
              <h3 className="text-white font-bold text-lg mb-6">Send an Inquiry</h3>
              <div className="flex flex-col gap-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">                  <div>
                    <label className="text-white/40 text-xs uppercase tracking-wide block mb-2">First Name</label>
                    <input
                      type="text"
                      placeholder="Juan"
                      className="w-full bg-gray-900 border border-white/10 rounded-lg px-4 py-3 text-white text-sm placeholder-white/20 focus:outline-none focus:border-orange-600 transition"
                    />
                  </div>
                  <div>
                    <label className="text-white/40 text-xs uppercase tracking-wide block mb-2">Last Name</label>
                    <input
                      type="text"
                      placeholder="dela Cruz"
                      className="w-full bg-gray-900 border border-white/10 rounded-lg px-4 py-3 text-white text-sm placeholder-white/20 focus:outline-none focus:border-orange-600 transition"
                    />
                  </div>
                </div>
                <div>
                  <label className="text-white/40 text-xs uppercase tracking-wide block mb-2">Email Address</label>
                  <input
                    type="email"
                    placeholder="juan@email.com"
                    className="w-full bg-gray-900 border border-white/10 rounded-lg px-4 py-3 text-white text-sm placeholder-white/20 focus:outline-none focus:border-orange-600 transition"
                  />
                </div>
                <div>
                  <label className="text-white/40 text-xs uppercase tracking-wide block mb-2">Phone Number</label>
                  <input
                    type="tel"
                    placeholder="+63 9XX XXX XXXX"
                    className="w-full bg-gray-900 border border-white/10 rounded-lg px-4 py-3 text-white text-sm placeholder-white/20 focus:outline-none focus:border-orange-600 transition"
                  />
                </div>
                <div>
                  <label className="text-white/40 text-xs uppercase tracking-wide block mb-2">Package Interest</label>
                  <select className="w-full bg-gray-900 border border-white/10 rounded-lg px-4 py-3 text-white/60 text-sm focus:outline-none focus:border-orange-600 transition appearance-none">
                    <option value="">Select a package</option>
                    <option value="kiosk">Kiosk Format — ₱299,000</option>
                    <option value="cafe">Café Format — ₱599,000</option>
                    <option value="flagship">Flagship Store — ₱1,200,000</option>
                  </select>
                </div>
                <div>
                  <label className="text-white/40 text-xs uppercase tracking-wide block mb-2">Message</label>
                  <textarea
                    rows={4}
                    placeholder="Tell us about your location, budget, or any questions..."
                    className="w-full bg-gray-900 border border-white/10 rounded-lg px-4 py-3 text-white text-sm placeholder-white/20 focus:outline-none focus:border-orange-600 transition resize-none"
                  />
                </div>
                <button className="w-full bg-orange-600 hover:bg-orange-700 text-white py-3 rounded-lg font-medium text-sm transition transform hover:scale-[1.02] mt-2">
                  Submit Inquiry
                </button>
              </div>
            </div> */}
          </div>
        </div>
      </section>

      <footer className="bg-black border-t border-white/5 px-8 md:px-16 lg:px-24 pt-16 pb-8 snap-end">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-12">
            <div className="col-span-2 md:col-span-1">
              <img src="https://hbylyyfhigscnrozlxqe.supabase.co/storage/v1/object/public/coffee-gusto/CGLOGOBAR-removebg.png" alt="Coffee Gusto" className="h-10 w-auto object-contain mb-3" />
              <p className="text-white/35 text-sm leading-relaxed font-light max-w-[220px]">
                Bringing premium coffee culture to every corner — one franchise at a time.
              </p>
            </div>
            {[
              { title: 'Navigate', links: [['Home', '#home'], ['Why Us', '#why'], ['Franchise', '#franchise'], ['Contact', '#contact']] },
              { title: 'Franchise', links: [['FAQ', '#']] },
              { title: 'Contact', links: [['coffeegustoph@gmail.com', '#'], ['+63 956 280 7813', '#'], ['Dasmariñas, Cavite', '#']] },
            ].map(({ title, links }) => (
              <div key={title}>
                <div className="text-white/30 text-xs tracking-widest uppercase font-medium mb-4">{title}</div>
                <ul className="flex flex-col gap-3">
                  {links.map(([label, href]) => (
                    <li key={label}>
                      <a href={href} className="text-white/50 text-sm hover:text-orange-400 transition font-light">{label}</a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div className="border-t border-white/5 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
            <span className="text-white/20 text-xs">© 2018 Coffee Gusto. All rights reserved.</span>
            <div className="flex gap-3">
               {[
                  { label: 'f', href: 'https://www.facebook.com/coffeegustoph' },
                  { label: 'ig', href: 'https://www.instagram.com/coffeegustoph?fbclid=IwY2xjawRmNGxleHRuA2FlbQIxMABicmlkETE1dUlnNHBiWkJkMFFkSnZ1c3J0YwZhcHBfaWQQMjIyMDM5MTc4ODIwMDg5MgABHnclNCSBdXzJqpubeggN6hN62vRxw067Hm4DVpSm5HhtBSgz3ZV0F4smeSA4_aem_mDPf-2gwPKXQYqFvGH9dtA' },
                  { label: 'in', href: '#' },
                ].map(({ label, href }) => (
                <a
                    key={label}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-8 h-8 border border-white/10 rounded-md flex items-center justify-center text-white/40 text-xs hover:border-orange-600 hover:text-orange-400 transition"
                  >
                   {label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </footer>

    </div>
  );
}